import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PaymentState {
  ui: {
    isSubmitting: boolean;
    responseError: string | null;
    bookingInProgress: boolean;
  };
}

const initialState: PaymentState = {
  ui: {
    isSubmitting: false,
    responseError: null,
    bookingInProgress: false,
  },
};

const paymentSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    setPaymentProcessing: (state) => {
      state.ui.isSubmitting = true;
    },
    setPaymentError: (state, action: PayloadAction<string>) => {
      state.ui.responseError = action.payload;
      state.ui.isSubmitting = false;
      state.ui.bookingInProgress = false;
    },
    setBookingInProgress: (state) => {
      state.ui.bookingInProgress = true;
    },
    clearBookingError: (state) => {
      state.ui.responseError = null;
    },
  },
});

export const { setPaymentProcessing, setPaymentError, setBookingInProgress, clearBookingError } = paymentSlice.actions;
export default paymentSlice.reducer;